import { isAstrollantas } from 'utils/miscellaneous'
import {
  cdmxsBranchesIds, queretaroBranchIds, leonBranchesIds, kiaIds,
} from 'vars'

export const isEasyVirtual = (offers) => {
  if (!Array.isArray(offers) || offers.length === 0) return false

  // Caso 1: solo hay una oferta de tipo "easy tradicional"
  if (offers.length === 1
    && (offers[0]?.offer_type || '').toLowerCase() === 'easy tradicional'
  ) {
    return true
  }

  // Escenario 2: Todas las ofertas visibles son "easy tradicional" o "easy directo"
  const visibleOffers = offers?.filter((o) => o?.show_price === true)

  if (visibleOffers?.length === 0) return false

  return visibleOffers?.every((o) => {
    const type = (o.offer_type || '').toLowerCase()
    return type === 'easy tradicional'
  })
}

export const branchesFiltered = (isEasyV, branches) => {
  if (isEasyV) {
    return branches
      ?.filter((b) => queretaroBranchIds?.includes(b?.branch_id))
  }

  return branches
    ?.filter((option) => !isAstrollantas(option.name))
    .filter((option) => option.name !== 'A Domicilio')
}

export const getBranchesByMaker = (branches = [], maker = '') => {
  if (!Array.isArray(branches) || branches.length === 0) return []

  const lowerMaker = maker.toLowerCase()
  const qroBranches = queretaroBranchIds
    ? branches.filter((b) => queretaroBranchIds.includes(b?.branch_id))
    : []

  const cdmxBranches = cdmxsBranchesIds
    ? branches.filter((b) => cdmxsBranchesIds.includes(b?.branch_id))
    : []

  const leonBranches = leonBranchesIds
    ? branches.filter((b) => leonBranchesIds.includes(b?.branch_id))
    : []

  switch (lowerMaker) {
    case 'toyota': {
      const toyotaBranches = branches.filter((b) => b?.name.toLowerCase().includes('toyota'))
      return [...toyotaBranches, ...qroBranches]
    }
    case 'hyundai': {
      const hyundaiBranches = branches.filter((b) => b?.name.toLowerCase().includes('hyundai'))
      return [...hyundaiBranches, ...qroBranches]
    }
    case 'honda': {
      const hondaBranches = branches.filter((b) => b?.name.toLowerCase().includes('honda'))
      return [...hondaBranches, ...qroBranches]
    }
    case 'nissan': {
      const nissanBranches = branches.filter((b) => b?.name.toLowerCase().includes('nissan'))
      return [...nissanBranches, ...qroBranches]
    }

    default:
      return [
        ...cdmxBranches,
        ...leonBranches,
        ...qroBranches,
      ]
  }
}

export const isCdmxOrEdoMexOrLeon = (branchId) => {
  if (!branchId) return false
  return (
    cdmxsBranchesIds?.includes(branchId) || kiaIds?.includes(branchId)
  )
}
